import ahsanSajidImage from "@/assets/ahsan-sajid.png";

export const PromptEngFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={ahsanSajidImage}
          alt="Ahsan Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "Prompt engineering has become as important as the code itself. When building AI-powered features, 
            the quality of your prompts directly impacts the quality of your output. I've seen projects succeed 
            or fail based on how well the prompts were crafted. It's a skill every modern developer needs 
            to master."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Ahsan Sajid</p>
            <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
